
























































import {Component, Vue} from 'vue-property-decorator'
import Header from '@/views/Header.vue'
import {gQuery} from "@/services/graphql";
import {ProfilesGQL} from "@dynamoit/shared/src/queries/ProfilesGQL";
import {AllProfiles, AllProfiles_profiles} from "@dynamoit/shared/generated/AllProfiles";
// import {API} from "aws-amplify";

@Component({
    components: {Header}
})
export default class Home extends Vue {

    private loading = false
    private profiles: AllProfiles_profiles[] = []

    public async mounted(): Promise<void> {
        try {
            this.loading = true
            const result = await gQuery<AllProfiles>(ProfilesGQL.ALL_PROFILES);

            // const d1 = await API.get('DynamoIt', '/subscriptions', {
            //
            // })

            // console.log(d1)

            this.profiles = result.data.profiles
        } finally {
            this.loading = false
        }
    }

}

